"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cloneFromTemplateArtifact = void 0;
const uuid_1 = require("uuid");
const cloneUtils_1 = require("../cloneUtils");
const node_1 = require("./node");
// busCertificate is a terminal, facility-less trigger node with an empty
// configuration (it resolves the servicing cycle / facility / credit agreement
// at run time from the pipeline run), so the clone only remints the artifact
// slug + ids and always nulls the facility/loan-product scoping.
const cloneFromTemplateArtifact = ({ artifactToClone, newArtifactDocumentId, cloneMap, }) => ({
    artifactSlug: (0, cloneUtils_1.getClonedArtifactSlug)(artifactToClone.artifactSlug, cloneMap),
    artifactDocumentId: newArtifactDocumentId,
    creditFacilitySlug: null,
    loanProductSlug: null,
    externalFilename: null,
    id: (0, uuid_1.v4)(),
    type: node_1.artifactType,
    configuration: {},
});
exports.cloneFromTemplateArtifact = cloneFromTemplateArtifact;
//# sourceMappingURL=clone.js.map